export function transformResourceComponentsToWiki(tiptapHtmlString: string): string {
    // Parse the HTML string into a document
    const parser = new DOMParser();
    const doc = parser.parseFromString(tiptapHtmlString, 'text/html');
  
    // Select all <resource-component> elements
    const resources = doc.querySelectorAll('resource-component');
    resources.forEach(resource => {
      const resourceUUID = resource.getAttribute('resourceuuid') || resource.getAttribute('resourceUUID') || '';
      const label = resource.textContent?.trim() || '';
  
      let replacementText = '';
      if (resourceUUID && label) {
        replacementText = `[[ ${resourceUUID} | ${label} ]]`;
      }
  
      // Replace the resource-component element with a text node containing the replacement text
      const textNode = doc.createTextNode(replacementText);
      resource.parentNode?.replaceChild(textNode, resource);
    });
  
    // Return the updated HTML content
    return doc.body.innerHTML;
  }
  
  export function transformWikiToResourceComponents(wikiText: string): string {
    const regex = /\[\[ *([^|<>\]]+?) *\| *([^\][]+?) *\]\]/gi
    return wikiText.replace(regex, (match, resourceUUID, label) => {
      resourceUUID = resourceUUID.trim();
      label = label ? label.trim() : resourceUUID;
      return `<resource-component resourceuuid="${resourceUUID}">${label}</resource-component>`;
    });
  }

export function countWikitextParts(wikiText: string): number {
  const regex = /\[\[ *([^|<>\]]+?) *\| *([^\][]+?) *\]\]/gi;
  const matches = wikiText.match(regex);
  return matches ? matches.length : 0;
}